export default "__VITE_ASSET__CtJGSffo__"